import { getField, updateField } from "vuex-map-fields";

export default {
	getters: {
		getField
	},
	mutations: {
		disableNavigation(state) {
			state.nav = false;
		},
		enableNavigation(state) {
			state.nav = true;
		},
		disableMenu(state) {
			state.menu = false;
		},
		enableMenu(state) {
			state.menu = true;
		},
		updateField
	},
	namespaced: true,
	state: () => ({
		nav: true,
		menu: true,
		pin: false,
		notePanel: false,
		navigationMenuMini: true
	})
};
